// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchForm_root__t8g0s","shadow":"SearchForm_shadow__tkooZ","root--icon-right":"SearchForm_root--icon-right___O6Rr"};